const digitalFulfilmentServicesData = [
  {
    title: "Content Production",
    description:
      "Produce design, copy, and multimedia at scale with brand QA and fast turnaround.",
    bullets: ["Design", "Copy", "Video", "Assets"],
    minHeight: 400,
  },
  {
    title: "Catalog Ops",
    description:
      "Create and maintain product catalogs with QA workflows, SEO enrichment, and change tracking.",
    bullets: ["SKU Setup", "Images", "SEO", "QC"],
    minHeight: 400,
  },
  {
    title: "Campaign Ops",
    description:
      "Build and ship landing pages, implement analytics, and run A/B tests with automation.",
    bullets: ["LPs", "Analytics", "A/B", "Automation"],
    minHeight: 400,
  },
  {
    title: "Data Ops",
    description:
      "Clean, migrate, and enrich data with deduplication, imports, and validation reports.",
    bullets: ["Cleaning", "Dedup", "Imports", "Reports"],
    minHeight: 400,
  },
  {
    title: "Support",
    description:
      "SLA‑backed delivery with playbooks, QA checks, and transparent reporting.",
    bullets: ["SLAs", "Playbooks", "Reporting", "QA"],
    minHeight: 400,
  },
  {
    title: "On‑Demand",
    description:
      "Rapid burst capacity with dedicated pods, daily standups, and tracked delivery.",
    bullets: ["Pods", "Standups", "Tracking", "Delivery"],
    minHeight: 400,
  },
  {
    title: "Localization",
    description:
      "Operate multi‑locale content with glossaries, QA checks, and approval workflows.",
    bullets: ["Locales", "Glossary", "QA", "Approvals"],
    minHeight: 400,
  },
  {
    title: "DAM & Taxonomy",
    description:
      "Organize assets with DAM, robust tagging, versioning, and rights management.",
    bullets: ["DAM", "Tags", "Versions", "Rights"],
    minHeight: 400,
  },
  {
    title: "Automation",
    description:
      "Automate workflows with templates and content pipelines, including QC gates.",
    bullets: ["Workflows", "Templates", "Pipelines", "QC"],
    minHeight: 400,
  },
];

export default digitalFulfilmentServicesData;
